'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { LiraRunAdvScript } from '@sbt-web/adv';
import { ViewportProvider } from '@sbt-web/hooks';
import { presencePing } from '@sbt-web/presence-ping';
import useUser from '@/client/contexts/UserContext';
import { useAdvToggle } from '@/client/hooks/useAdvToggle';
import { advFallbackConfigDesktop } from '@/shared/adv/lira/fallbackConfig/desktopConfig';
import { advFallbackConfigMsite } from '@/shared/adv/lira/fallbackConfig/msiteConfig';
import { viewTrackingAction } from '@/tools/tracking/ProfileTracking';
import type { UserProfileDataResponse } from '@/types';
import CommandBox from '../CommandBox';
import Listing from '../Listing';
import { useDataLayer } from '../SubitoScripts/useDataLayer';
import UserData from '../UserData';
import '@sbt-web/item-card/dist/index.css';
import styles from './index.module.scss';
const initPresencePing = (userId: string) => {
  presencePing({
    userId,
    presenceApiUrl: process.env.NEXT_PUBLIC_TRUST_PRESENCE_BASE_URL,
    profileApiUrl: process.env.NEXT_PUBLIC_TRUST_PROFILE_BASE_URL,
    hadesPublicBase: process.env.NEXT_PUBLIC_HADES_BASE_URL,
    intervalTime: 3000
  });
};
export const ProfilePage = t0 => {
  const $ = _c(34);
  const {
    data,
    requestInfo,
    device
  } = t0;
  const {
    user
  } = useUser();
  const {
    noAdvToggle,
    optimizelyReady
  } = useAdvToggle();
  let t1;
  if ($[0] !== user) {
    t1 = {
      user,
      pageType: "user-profile",
      envName: process.env.NEXT_PUBLIC_INTERNAL_ENVIRONMENT
    };
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useDataLayer(t1);
  let t2;
  if ($[2] !== requestInfo.ownerId) {
    t2 = () => {
      viewTrackingAction(requestInfo.ownerId);
    };
    $[2] = requestInfo.ownerId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== requestInfo) {
    t3 = [requestInfo];
    $[4] = requestInfo;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== data.trustInfo?.presence || $[7] !== user) {
    t4 = () => {
      if (user?.id && data.trustInfo?.presence.enabled) {
        initPresencePing(user.id);
      }
    };
    $[6] = data.trustInfo?.presence;
    $[7] = user;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = user?.id;
  let t6;
  if ($[9] !== data || $[10] !== t5) {
    t6 = [data, t5];
    $[9] = data;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useEffect(t4, t6);
  const t7 = device ?? "mobile";
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CommandBox />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== noAdvToggle || $[14] !== optimizelyReady) {
    t9 = optimizelyReady && noAdvToggle !== "B" && <LiraRunAdvScript vertical="subito" pageType="userprofile" env={process.env.NEXT_PUBLIC_INTERNAL_ENVIRONMENT} fallbackHebeConfig={{
      desktop: advFallbackConfigDesktop,
      msite: advFallbackConfigMsite
    }} />;
    $[13] = noAdvToggle;
    $[14] = optimizelyReady;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== data.feedbacks || $[17] !== data.shop || $[18] !== data.trustInfo || $[19] !== data.user || $[20] !== requestInfo.ownerId) {
    t10 = data.user && <UserData ownerId={requestInfo.ownerId} user={data.user} trustInfo={data.trustInfo} feedbacks={data.feedbacks} shop={data.shop} />;
    $[16] = data.feedbacks;
    $[17] = data.shop;
    $[18] = data.trustInfo;
    $[19] = data.user;
    $[20] = requestInfo.ownerId;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== data.isPro || $[23] !== data.showProAds || $[24] !== data.userAdsData || $[25] !== requestInfo.ownerId) {
    t11 = <Listing ownerId={requestInfo.ownerId} userAdsData={data.userAdsData} showProAds={data.showProAds} isPro={data.isPro} />;
    $[22] = data.isPro;
    $[23] = data.showProAds;
    $[24] = data.userAdsData;
    $[25] = requestInfo.ownerId;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <div className={styles.profile_wrapper}>{t10}{t11}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t7 || $[32] !== t9) {
    t13 = <ViewportProvider defaultType={t7}>{t8}{t9}{t12}</ViewportProvider>;
    $[30] = t12;
    $[31] = t7;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};